export default __webpack_public_path__ + "331927b5d5bceb82a9cbe5dc4c6d1f17.ttf";